.markdown {
  font-size: var(--mantine-font-size-sm);
  overflow-wrap: break-word;

  ul {
    padding-inline-start: 2rem;
  }

  h1,
  h2 {
    font-size: var(--mantine-font-size-md);
    font-weight: 600;
  }

  h3,
  h4,
  h5,
  h6 {
    font-size: var(--mantine-font-size-sm);
    font-weight: 600;
  }
}
